import { Container } from "@/components/Container";
import { ProductDetails } from "@/components/product/ProductDetails";
import { PurchaseCard } from "@/components/product/PurchaseCard";
import StickyMobileCta from "@/components/StickyMobileCta";
import { STORE } from "@/constants/testIds";
import { PRODUCT } from "@/data/content";
import LiveReviewPromo from "@/components/LiveReviewPromo";

export default function Product() {
  return (
    <div data-testid={STORE.productPage} className="bg-[var(--ibp-offwhite)]">
      <section className="bg-[var(--ibp-navy-950)] py-10 text-white sm:py-14">
        <Container>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#E7BE4A]">
            Illinois-first online study system
          </p>
          <h1 className="mt-3 max-w-3xl font-[var(--font-heading)] text-3xl font-bold leading-tight tracking-[-0.02em] sm:text-4xl lg:text-5xl">
            {PRODUCT.title}
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-white/80 sm:text-base">
            {PRODUCT.shortDesc}
          </p>
        </Container>
      </section>

      <Container className="py-12 sm:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr,380px] lg:gap-12">
          <ProductDetails />
          <div>
            <PurchaseCard />
          </div>
        </div>
        <LiveReviewPromo source="product" />
      </Container>
      <StickyMobileCta source="product_sticky" />
    </div>
  );
}
